export default __webpack_public_path__ + "media/images/stopwatch-cef78f25109e0c37cdfb2fd8875b8a93.svg";